export const isWindowDefined = typeof window !== 'undefined';
